import { Controller } from "@hotwired/stimulus";

/**
 * Toggles visibility of the "Share this domain" block and the "Invite team members"
 * block based on the Access Level checkbox (private vs public).
 * - Checked (private): show invitations, hide share.
 * - Unchecked (public): hide invitations, show share.
 */
export default class extends Controller {
  static targets = [
    "checkbox",
    "shareSection",
    "invitationsSection",
    "unsavedWarning",
  ];

  toggle() {
    const input = this.checkboxTarget.querySelector('input[type="checkbox"]');
    if (!input) return;
    const isPrivate = input.checked;
    this.invitationsSectionTarget.classList.toggle("hidden", !isPrivate);
    this.shareSectionTarget.classList.toggle("hidden", isPrivate);

    // Show/hide the "save to make public" warning when toggling to public
    if (this.hasUnsavedWarningTarget) {
      this.unsavedWarningTarget.classList.toggle("hidden", isPrivate);
    }
  }
}
